<!--
 * @Description: 屏幕中央的播放按钮
 * @Date: 2021-12-15 11:59:20
 * @LastEditTime: 2021-12-17 12:06:14
-->
<template lang="pug">
  transition(name="fade")
    //- div.play-background(v-if="playState === PLAY_STATE.PAUSED && !!playUrl" v-show="initFlag")
      div.play-button

    //- '-99': { value: -99, label: '已禁用', color: '#aaa' }
    //- 0: { value: 0, label: '未开播', color: '#70b603' },
    //- 1: { value: 1, label: '直播中', color: '#108de9' },
    //- 2: { value: 2, label: '已结束', color: '#aaa' },
    //- 3: { value: 3, label: '预告', color: '#f59a23' },

    //- 没封面图才显示出文字
    div.recorded-tips(v-if="isActive === 0 && !hasCoverImage") {{ '当前未开播' }}
    div.recorded-tips(v-if="isActive === 2 && !playUrl" v-show="initFlag") {{ '直播已结束，回放生成中' }}
    div.recorded-tips(v-if="isActive === 3 && !hasCoverImage") {{ '直播预告' }}
    div.recorded-tips(v-if="isActive === -99") {{ '暂无内容' }}
</template>

<script>
import { mapState } from 'vuex';
import { PLAY_STATE } from '@/constants/room';
export default {
  name: 'compPlay',
  data() {
    return {
      PLAY_STATE,
      initFlag: false,
    };
  },
  computed: {
    ...mapState({
      playState: state => state.player.playState,
      playUrl: state => state.player.playUrl,
      isActive: state => state.player.isActive,

      // 是否有封面图
      hasCoverImage: (state) => {
        if (
          state?.player?.liveInfo?.coverImages
          && state.player.liveInfo.coverImages.length > 0
          && state.player.liveInfo.coverImages[0].url
        ) {
          // console.log(state.player.liveInfo.coverImages)
          return true
        }
        return false
      },

    }),
  },
  methods: {
  },

  mounted() {
    setTimeout(() => {
      this.initFlag = true;
    }, 200)
  },
};
</script>

<style lang="stylus" scoped>
  .fade-leave-to
    transform translate(-50%, -50%) scale(1.5) !important
    opacity 0
  .fade-leave-active
    transition all 0.5s ease
  .play-background
    width 100px
    height 100px
    border-radius 50%
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    background-color rgba(255, 255, 2555, 0.2)
    cursor pointer
    transform-origin center center
    .play-button
      width 0
      height 0
      border-left 30px solid rgba(255, 255, 255, 0.8)
      border-top 20px solid transparent
      border-bottom 20px solid transparent
      position absolute
      top 50%
      left 55%
      transform translate(-50%,-50%)
      border-radius 2px

   .recorded-tips
      color #fff
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      font-size 1.5em
      width 100%
      text-align center

</style>
